// localStorage helpers for per-browser conveniences (settings and the local personal best).
// Shared scores go to the start.ng leaderboard, never here.
const SETTINGS_KEY = 'pk3d.settings.v1';
const BEST_KEY = 'pk3d.best.v1';
const PENDING_KEY = 'pk3d.pendingRun.v1';

const prefersReducedMotion = () => {
  try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch { return false; }
};

export const DEFAULT_SETTINGS = {
  volume: 0.8,
  sound: true,
  crowd: true,
  preview: true,
  replays: true,
  reducedMotion: prefersReducedMotion(),
  quality: 'auto',
};

function read(key, store = localStorage) {
  try { return JSON.parse(store.getItem(key) || 'null'); } catch { return null; }
}
function write(key, value, store = localStorage) {
  try { store.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
}

export function loadSettings() {
  return { ...DEFAULT_SETTINGS, ...(read(SETTINGS_KEY) || {}) };
}
export function saveSettings(s) { write(SETTINGS_KEY, s); }

export function loadBest() {
  const b = read(BEST_KEY);
  return b && typeof b.points === 'number' ? b : null;
}

/** Stores the run if it beats the local best (by points). Returns true when it is a new best. */
export function recordBest(stats) {
  const prev = loadBest();
  if (prev && prev.points >= stats.points) return false;
  write(BEST_KEY, { ...stats, at: Date.now() });
  return true;
}

/** A finished run kept for the trip through start.ng sign-in, so it can be saved on return. */
export function stashPendingRun(stats) { write(PENDING_KEY, { stats, at: Date.now() }, sessionStorage); }
export function takePendingRun() {
  const p = read(PENDING_KEY, sessionStorage);
  try { sessionStorage.removeItem(PENDING_KEY); } catch { /* ignore */ }
  if (!p || !p.stats || Date.now() - p.at > 2 * 60 * 60 * 1000) return null;
  return p.stats;
}
export function peekPendingRun() { return !!read(PENDING_KEY, sessionStorage); }
